// ─────────────────────────────────────────────────────────────
// STOPS SERVICE — Phlebotomist stop lifecycle
// ─────────────────────────────────────────────────────────────
import axios from '../axios';
import { BASE_URL, encodeQueryFilter } from '../Utils';

const STOPS_URL = `${BASE_URL}/stops`;

export function getStops(filter={}) {
   return axios({
    "url": `${STOPS_URL}?filter=${encodeQueryFilter(filter)}`,
    "method": "get",
  })
}

export function updateStopStatus(stopId, status) {
  return axios({
    url: `${STOPS_URL}/${stopId}/status`,
    method: 'put',
    data: { status },
  });
}

export function updateDriverUser(stopId, driverId) {
    return axios({
    "url": `${STOPS_URL}/${stopId}/driver`,
    "method": "put",
    data: {driverId}
  })
}

export function addDropSiteFacilityId(stopId, dropFacilityId) {
  return axios({
    url: `${STOPS_URL}/${stopId}/update-drop-facility`,
    method: "put",
    data: {
      dropFacilityId,
    },
  });
}

/**
 * PUT /api/stops/:stopId/collected-counts
 * Body: { Blood: 3, Urine: 1, ... }  — map of specimenType → count collected
 * → Called when phleb confirms how many of each type were collected
 */
export function updateCollectedCounts(stopId, collectedCounts) {
  return axios({
    url: `${STOPS_URL}/${stopId}/collected-counts`,
    method: 'put',
    data: collectedCounts,
  });
}

/**
 * PUT /api/stops/:stopId/driver-notes
 * Body: { driverNotes: "Handle with care" }
 * → Called when phleb saves optional note at "Ready for Pickup" step
 * → Visible to the assigned driver on their route detail screen
 */
export function updatePhlebNotes(stopId, phlebNotes) {
  return axios({
    url: `${STOPS_URL}/${stopId}/phleb-notes`,
    method: 'put',
    data: { phlebNotes },
  });
}

export function updateDriverNotes(stopId, driverNotes) {
  return axios({
    url: `${STOPS_URL}/${stopId}/driver-notes`,
    method: 'put',
    data: { driverNotes },
  });
}

export function getSpecimenTypes() {
  return axios({
    url: `${BASE_URL}/specimen-types`,
    method: 'get',
  });
}

export function addStopsUser(data) {
  return axios({
    url: `${BASE_URL}/stops/add`,
    method: "post",
    data
  })
}